var exports = {
  "h": "description__66mKP0",
  "R": "PreviewLabel__8XVnkq",
};

module.exports = exports;
